/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {Toaster} from "react-hot-toast";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const container = document.getElementById('root');
const root = createRoot(container);
const theme = createTheme();
root.render(
  <BrowserRouter basename={baseUrl}>
      <ThemeProvider theme={theme}>
          <Toaster
              position="bottom-center"
              toastOptions={{
                  duration: 5000,
                  style: {
                      borderRadius: '10px',
                      background: '#333',
                      color: '#fff',
                  }
              }}
          />
          <App />
      </ThemeProvider>
  </BrowserRouter>);

serviceWorkerRegistration.register();